export const HUBSPOT_HELPDOC_URL = 'https://help.drift.com/article/hubspot-integration/'
export const DRIP_HELPDOC_URL = 'https://help.drift.com/article/drip-integration/'
export const FULLSTORY_HELPDOC_URL = 'https://help.drift.com/article/fullstory-integration/'
export const HELP_CENTER_HELPDOC_URL = 'https://help.drift.com/article/knowledge-base-and-help-doc-integrations/'
export const ZAPIER_HELPDOC_URL = 'https://help.drift.com/article/zapier-integration/'
export const INTERCOM_HELPDOC_URL = 'http://help.drift.com/integrations/intercom-integration'
export const LINKEDIN_HELPDOC_URL = 'https://help.drift.com/article/linkedin-integration/'



// WEBPACK FOOTER //
// ./src/scripts/constants/HelpDocConstants.js